var SimpleSubscription = /** @class */ (function () {
    function SimpleSubscription(close, observer) {
        this.close = close;
        this.observer = observer;
        if (this.observer.start) {
            this.observer.start(this);
        }
    }
    SimpleSubscription.prototype.unsubscribe = function () {
        if (!this.closed) {
            this.closed = true;
            this.close(this.observer);
            delete this.close;
            delete this.observer;
        }
    };
    return SimpleSubscription;
}());
export { SimpleSubscription };
export function createOrPassthroughObserver(onNextOrObserver, onError, onComplete) {
    return (typeof onNextOrObserver === 'function'
        ? {
            next: onNextOrObserver,
            error: onError,
            complete: onComplete,
        }
        : onNextOrObserver);
}
export function createPromiseFromObservable(observable) {
    return new Promise(function (resolve, reject) {
        observable.subscribe({
            start: function (subscription) {
                this.subscription = subscription;
            },
            next: function (value) {
                this.value = value;
            },
            complete: function () {
                resolve(this.value);
                this.subscription.unsubscribe();
            },
            error: function (e) {
                reject(e);
                this.subscription.unsubscribe();
            }
        });
    });
}
//# sourceMappingURL=Observable.js.map